<p-accordion
  (activeIndexChange)="activeIndexChange($event)"
  class="w-full"
  styleClass="sku-age-accordion"
>
  <p-accordionTab>
    <ng-template pTemplate="header">
      <span class="flex justify-between w-full">
        <span>
          <span class="accordion-heading head-h3">
            Portfolio Optimization Methodology & Framework
          </span>
        </span>
        <span class="flex items-center">
          @if (showAccordionContent) {
            <app-svg-icon
              icon="square-minus"
              color="#000"
              padding="12px"
            ></app-svg-icon>
          }
          @if (!showAccordionContent) {
            <app-svg-icon
              icon="square-plus"
              color="#000"
              padding="12px"
            ></app-svg-icon>
          }
        </span>
      </span>
    </ng-template>
    <div class="m-0 accordion-imgs">
      @if (skuAge === _skuAge._6to12Months) {
        <div class="flex justify-center">
          <img src="/assets/images/6to12_months.svg" alt="6to12Months" />
        </div>
      }
      @if (skuAge === _skuAge._12to15Months) {
        <div class="flex justify-center">
          <img src="/assets/images/12to15_img.svg" alt="12to15Months" />
        </div>
      }
      @if (skuAge === _skuAge._15to24Months) {
        <div class="flex justify-center">
          <img src="/assets/images/15_to_24.svg" alt="15to24Months" />
        </div>
      }
      @if (skuAge === _skuAge._above24Months) {
        <div class="flex justify-center">
          <img src="/assets/images/24more_new_img_.svg" alt="above24Months" />
        </div>
      }
    </div>
  </p-accordionTab>
</p-accordion>
